<template>
  <b-form-input
    :value="value"
    @change="v => $emit('change', {value: v})"
    type="text"
    placeholder="value"
    :state="showErrors && !value ? false : null"
    required />
</template>

<script>
  export default {
    name: 'ArrayInput',
    props: {
      showErrors: Boolean,
      value: String,
    },
  };
</script>

<style scoped>
</style>